/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createConstantNode } from '../../factoriesAny.js';
export var ConstantNodeDependencies = {
  NodeDependencies,
  createConstantNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesConstantNode.generated.js
// module id = htV+
// module chunks = 3